import axios from '@/utils/request';

const v1 = `v1/admin/companies`;
export const getCompany = ({ company_id = null }) => axios.get(`${v1}/company`, { params: { company_id } });
export const getCompanies = () => axios.get(`${v1}/index`);
export const updateCompany = (data) => axios.post(`${v1}`, data);
export const deleteCompany = (id) => axios.post(`${v1}/delete`, id);
